import React from 'react'
import './BlinkingCursor.css'

export default function BlinkingCursor() {

  return (
    <div className='blinkingCursor'>▂</div>
  )
}
